/* -- cone add component import 初始化 start，勿删 --*/
import CnFilterAlcProtoIndex from './cn-filter-alc/protoIndex';
import CnTableAlcProtoIndex from './cn-table-alc/protoIndex';
import CnPageAlcProtoIndex from './cn-page-alc/protoIndex';
import CnTabAlcProtoIndex from './cn-tab-alc/protoIndex';
import CnFormAlcProtoIndex from './cn-form-alc/protoIndex';
import CnDialogAlcProtoIndex from './cn-dialog-alc/protoIndex';
import CnFormDialogAlcProtoIndex from './cn-form-dialog-alc/protoIndex';
import CnMessageAlcProtoIndex from './cn-message-alc/protoIndex';
import PageAlcProtoIndex from './page/protoIndex';
import CnCardAlcProtoIndex from './cn-card-alc/protoIndex';
import CnCardSubCardAlcProtoIndex from './cn-card-sub-card-alc/protoIndex';
import CnStepAlcProtoIndex from './cn-step-alc/protoIndex';
import CnLeftTreeAlcProtoIndex from './cn-left-tree-alc/protoIndex';
import CnResultProtoIndex from './cn-result-alc/protoIndex';
import CnListProtoIndex from './cn-list-alc/protoIndex';
import CnEntryPointsProtoIndex from './cn-entry-points-alc/protoIndex';
import CnSliderProtoIndex from './cn-slider-alc/protoIndex';
import CnDetailInfoProtoIndex from './cn-detail-info-alc/protoIndex';
// import CnFormatProtoIndex from './cn-format-alc/protoIndex';
// import CnStatisticCardProProtoIndex from './cn-statistic-card-pro-alc/protoIndex';
/* -- cone add component import 初始化 end，勿删 --*/
import CnLayoutBundle from '@cainiaofe/cn-ui-layout/es/lowcode/protoIndex';
// 通过arr控制输出的顺序
const bundle = [
    /* -- cone add component bundle 初始化 start，勿删 --*/
    CnFilterAlcProtoIndex,
    CnTableAlcProtoIndex,
    CnFormAlcProtoIndex,
    CnFormDialogAlcProtoIndex,
    CnPageAlcProtoIndex,
    CnTabAlcProtoIndex,
    CnDialogAlcProtoIndex,
    CnMessageAlcProtoIndex,
    PageAlcProtoIndex,
    CnCardAlcProtoIndex,
    CnCardSubCardAlcProtoIndex,
    CnStepAlcProtoIndex,
    CnLeftTreeAlcProtoIndex,
    CnResultProtoIndex,
    CnListProtoIndex,
    CnEntryPointsProtoIndex,
    CnSliderProtoIndex,
    CnDetailInfoProtoIndex,
    // CnFormatProtoIndex,
    // CnStatisticCardProProtoIndex,
    /* -- cone add component bundle 初始化 end，勿删 --*/
    ...CnLayoutBundle,
];
export default bundle;
